import { useState, useEffect } from 'react';

const HomePage = () => {
  const [currentStory, setCurrentStory] = useState(0);
  const [donationAmount, setDonationAmount] = useState('');
  const [showDonationForm, setShowDonationForm] = useState(false);
  const [selectedCase, setSelectedCase] = useState<number | null>(null);
  const [categoryFilter, setCategoryFilter] = useState<string | null>(null);

  const stories = [
    {
      id: 1,
      name: '小美',
      age: 8,
      type: '教育支援案例',
      story: '來自偏遠部落的小美，因為家庭經濟困難無法上學。透過協會的教育支援計劃，她現在不僅能正常上課，還在學校的舞蹈比賽中獲得第一名。每月需要教育補助金3,000元。',
      image: 'https://public.readdy.ai/ai/img_res/14ca5483e7a3c3afb6429313f8ee8f20.jpg',
      progress: 85,
      monthlyNeed: 3000,
      supporters: 12,
      raised: 2550,
      donors: [
        { name: '王小明', amount: 500 },
        { name: '李美華', amount: 1000 },
        { name: '張志強', amount: 300 },
        { name: '陳雅婷', amount: 200 },
        { name: '林建宏', amount: 550 }
      ]
    },
    {
      id: 2,
      name: '阿明家庭',
      age: 35,
      type: '職業培訓案例',
      story: '阿明是單親爸爸，獨自撫養三個孩子。協會提供的職業培訓讓他學會了木工技藝，現在能夠穩定工作，孩子們也重新展露笑容。職訓期間需要生活補助每月8,000元。',
      image: 'https://readdy.ai/api/search-image?query=A%20indigenous%20father%20with%20three%20children%20working%20on%20traditional%20woodcraft%20together%2C%20warm%20family%20atmosphere%20in%20a%20simple%20wooden%20house%2C%20mountains%20in%20background%2C%20natural%20lighting%20showing%20hope%20and%20determination%2C%20clean%20simple%20background&width=600&height=400&seq=case2&orientation=landscape',
      progress: 92,
      monthlyNeed: 8000,
      supporters: 18,
      raised: 7360,
      donors: [
        { name: '黃淑芬', amount: 2000 },
        { name: '吳俊傑', amount: 1500 },
        { name: '劉佳玲', amount: 1000 },
        { name: '周明德', amount: 860 },
        { name: '鄭雅文', amount: 2000 }
      ]
    },
    {
      id: 3,
      name: '小雯',
      age: 7,
      type: '血癌治療案例',
      story: '小雯被診斷出急性淋巴性白血病，需要長期化療。家庭無力負擔龐大醫療費用，孩子的生命正在與時間賽跑。每月化療費用需要25,000元，讓我們一起守護這個勇敢的小天使。',
      image: 'https://readdy.ai/api/search-image?query=A%20brave%20young%20girl%20with%20cancer%20wearing%20colorful%20headscarf%20in%20hospital%20room%2C%20holding%20teddy%20bear%20with%20hopeful%20smile%2C%20medical%20equipment%20in%20background%2C%20warm%20lighting%20showing%20courage%20and%20hope%2C%20clean%20background%20highlighting%20the%20child&width=600&height=400&seq=case3&orientation=landscape',
      progress: 78,
      monthlyNeed: 25000,
      supporters: 45,
      raised: 19500,
      donors: [
        { name: '許文龍', amount: 5000 },
        { name: '蔡依林', amount: 3000 },
        { name: '謝金燕', amount: 2500 },
        { name: '林志玲', amount: 5000 },
        { name: '蕭敬騰', amount: 4000 }
      ]
    },
    {
      id: 4,
      name: '小華',
      age: 6,
      type: '醫療救助案例',
      story: '小華患有先天性心臟病，家庭無力負擔手術費用。透過協會的醫療救助基金，小華成功接受手術治療，現在能和其他孩子一樣快樂奔跑。手術費用需要120,000元。',
      image: 'https://readdy.ai/api/search-image?query=A%20young%20indigenous%20boy%20playing%20happily%20with%20other%20children%20in%20a%20hospital%20garden%2C%20recovered%20from%20heart%20surgery%2C%20bright%20smile%2C%20medical%20staff%20watching%20with%20joy%2C%20hopeful%20atmosphere%20with%20flowers%20and%20sunshine%2C%20clean%20background&width=600&height=400&seq=case4&orientation=landscape',
      progress: 95,
      monthlyNeed: 120000,
      supporters: 67,
      raised: 114000,
      donors: [
        { name: '陳建銘', amount: 20000 },
        { name: '林淑惠', amount: 15000 },
        { name: '張家豪', amount: 30000 },
        { name: '王雅琪', amount: 25000 },
        { name: '李國華', amount: 24000 }
      ]
    },
    {
      id: 5,
      name: '阿嬤小玉',
      age: 72,
      type: '失智症照護案例',
      story: '小玉阿嬤患有阿茲海默症，需要24小時專業照護。家人無法負擔照護費用，阿嬤的記憶正在逐漸消失。每月照護費用需要18,000元，讓阿嬤在愛中度過餘生。',
      image: 'https://readdy.ai/api/search-image?query=Elderly%20indigenous%20grandmother%20with%20gentle%20smile%20being%20cared%20for%20by%20family%20members%2C%20peaceful%20expression%20in%20traditional%20home%20setting%2C%20warm%20lighting%20showing%20love%20and%20care%2C%20flowers%20and%20traditional%20decorations%2C%20clean%20background&width=600&height=400&seq=case5&orientation=landscape',
      progress: 67,
      monthlyNeed: 18000,
      supporters: 23,
      raised: 12060,
      donors: [
        { name: '楊麗花', amount: 3000 },
        { name: '洪金寶', amount: 2500 },
        { name: '劉德華', amount: 2000 },
        { name: '周星馳', amount: 2560 },
        { name: '成龍', amount: 2000 }
      ]
    },
    {
      id: 6,
      name: '小傑',
      age: 14,
      type: '腦瘤治療案例',
      story: '小傑被診斷出惡性腦瘤，需要立即進行手術和放射治療。這個原本活潑好動的孩子現在每天都在與病魔搏鬥。手術及治療費用需要180,000元，請幫助他重新站起來。',
      image: 'https://readdy.ai/api/search-image?query=A%20teenage%20boy%20with%20brain%20tumor%20in%20hospital%20bed%20surrounded%20by%20family%2C%20determined%20expression%20despite%20illness%2C%20medical%20equipment%20and%20get-well%20cards%20visible%2C%20hopeful%20atmosphere%20with%20natural%20lighting%2C%20clean%20background&width=600&height=400&seq=case6&orientation=landscape',
      progress: 73,
      monthlyNeed: 180000,
      supporters: 89,
      raised: 131400,
      donors: [
        { name: '郭台銘', amount: 50000 },
        { name: '張忠謀', amount: 30000 },
        { name: '聯發科', amount: 25000 },
        { name: '中華電信', amount: 15000 },
        { name: '台灣大哥大', amount: 15000 }
      ]
    },
    {
      id: 7,
      name: '單親媽媽小雲',
      age: 28,
      type: '家庭扶助案例',
      story: '小雲獨自撫養兩個孩子，透過協會的家庭扶助計劃獲得育兒支援和職業訓練，現在在社區開設小型托育中心。每月生活補助需要6,000元。',
      image: 'https://readdy.ai/api/search-image?query=Young%20indigenous%20single%20mother%20with%20two%20children%20in%20a%20bright%20childcare%20center%2C%20children%20playing%20happily%2C%20mother%20working%20with%20dedication%2C%20warm%20family%20atmosphere%2C%20traditional%20and%20modern%20elements%20combined%2C%20clean%20background&width=600&height=400&seq=case7&orientation=landscape',
      progress: 88,
      monthlyNeed: 6000,
      supporters: 22,
      raised: 5280,
      donors: [
        { name: '賴清德', amount: 1500 },
        { name: '柯文哲', amount: 1000 },
        { name: '侯友宜', amount: 800 },
        { name: '盧秀燕', amount: 980 },
        { name: '黃偉哲', amount: 1000 }
      ]
    },
    {
      id: 8,
      name: '災後重建',
      age: 0,
      type: '緊急救助案例',
      story: '颱風重創部落後，20戶家庭失去家園。協會立即啟動緊急救助，提供臨時住所、食物和重建資金，幫助族人重新站起來。重建費用需要300,000元。',
      image: 'https://readdy.ai/api/search-image?query=Indigenous%20community%20rebuilding%20after%20natural%20disaster%2C%20people%20working%20together%20to%20construct%20new%20traditional%20houses%2C%20hope%20and%20determination%20in%20their%20faces%2C%20mountains%20and%20clear%20sky%20in%20background%2C%20community%20spirit%2C%20clean%20background&width=600&height=400&seq=case8&orientation=landscape',
      progress: 45,
      monthlyNeed: 300000,
      supporters: 134,
      raised: 135000,
      donors: [
        { name: '台積電', amount: 50000 },
        { name: '鴻海', amount: 30000 },
        { name: '聯發科', amount: 25000 },
        { name: '中華電信', amount: 15000 },
        { name: '台灣大哥大', amount: 15000 }
      ]
    },
    {
      id: 9,
      name: '語言復振班',
      age: 10,
      type: '語言保存案例',
      story: '部落的母語逐漸流失，協會成立語言復振班，邀請耆老教授族語，讓孩子們重新學會祖先的語言。教材製作與耆老津貼需要每月8,000元。',
      image: 'https://readdy.ai/api/search-image?query=Indigenous%20elder%20teaching%20traditional%20language%20to%20children%20in%20a%20cultural%20center%2C%20children%20listening%20attentively%2C%20traditional%20books%20and%20learning%20materials%2C%20intergenerational%20knowledge%20transfer%2C%20warm%20educational%20atmosphere%2C%20clean%20background&width=600&height=400&seq=case9&orientation=landscape',
      progress: 62,
      monthlyNeed: 8000,
      supporters: 11,
      raised: 4960,
      donors: [
        { name: '原住民委員會', amount: 2000 },
        { name: '文化部', amount: 1500 },
        { name: '教育部', amount: 800 },
        { name: '客委會', amount: 360 },
        { name: '內政部', amount: 300 }
      ]
    },
    {
      id: 10,
      name: '青少年課輔班',
      age: 15,
      type: '課業輔導案例',
      story: '偏遠地區的青少年缺乏學習資源，協會設立課輔班提供免費補習和升學輔導，已有30位學生考上理想學校。每月師資費用需要12,000元。',
      image: 'https://readdy.ai/api/search-image?query=Indigenous%20teenagers%20studying%20together%20in%20a%20bright%20tutoring%20center%2C%20focused%20expressions%20while%20learning%2C%20books%20and%20computers%2C%20teacher%20helping%20students%2C%20academic%20success%20atmosphere%2C%20mountains%20visible%20through%20windows%2C%20clean%20background&width=600&height=400&seq=case10&orientation=landscape',
      progress: 81,
      monthlyNeed: 12000,
      supporters: 19,
      raised: 9720,
      donors: [
        { name: '台大', amount: 3000 },
        { name: '清大', amount: 2000 },
        { name: '交大', amount: 1500 },
        { name: '成大', amount: 1720 },
        { name: '政大', amount: 1500 }
      ]
    },
    {
      id: 11,
      name: '小安家庭',
      age: 5,
      type: '罕見疾病案例',
      story: '小安患有罕見的脊髓性肌肉萎縮症，需要昂貴的基因治療藥物。這個勇敢的孩子每天都在努力復健，希望能像其他孩子一樣正常走路。治療費用需要350,000元。',
      image: 'https://readdy.ai/api/search-image?query=A%20young%20child%20with%20rare%20disease%20doing%20physical%20therapy%20with%20therapist%2C%20determined%20expression%2C%20medical%20rehabilitation%20equipment%2C%20family%20watching%20with%20hope%2C%20bright%20therapy%20room%20with%20encouraging%20atmosphere%2C%20clean%20background&width=600&height=400&seq=case11&orientation=landscape',
      progress: 34,
      monthlyNeed: 350000,
      supporters: 156,
      raised: 119000,
      donors: [
        { name: '罕見疾病基金會', amount: 50000 },
        { name: '慈濟基金會', amount: 30000 },
        { name: '紅十字會', amount: 20000 },
        { name: '伊甸基金會', amount: 10000 },
        { name: '陽光基金會', amount: 9000 }
      ]
    },
    {
      id: 12,
      name: '阿公阿嬤',
      age: 78,
      type: '重症照護案例',
      story: '阿公患有末期腎臟病需要洗腎，阿嬤中風後需要長期照護。這對相伴一生的老夫妻面臨龐大醫療費用，子女也因經濟困難無法負擔。每月醫療費用需要22,000元。',
      image: 'https://readdy.ai/api/search-image?query=Elderly%20indigenous%20couple%20holding%20hands%20in%20hospital%2C%20showing%20love%20and%20support%20despite%20illness%2C%20medical%20equipment%20visible%2C%20family%20members%20caring%20for%20them%2C%20warm%20lighting%20showing%20enduring%20love%2C%20clean%20background&width=600&height=400&seq=case12&orientation=landscape',
      progress: 56,
      monthlyNeed: 22000,
      supporters: 78,
      raised: 12320,
      donors: [
        { name: '長庚醫院', amount: 5000 },
        { name: '台大醫院', amount: 3000 },
        { name: '榮總', amount: 2000 },
        { name: '馬偕醫院', amount: 1320 },
        { name: '亞東醫院', amount: 1000 }
      ]
    },
    {
      id: 13,
      name: '小婷',
      age: 12,
      type: '燒燙傷復健案例',
      story: '小婷在意外中全身60%燒燙傷，需要多次植皮手術和長期復健。這個堅強的女孩從未放棄希望，夢想著重新回到學校和同學們一起學習。復健費用需要80,000元。',
      image: 'https://readdy.ai/api/search-image?query=A%20brave%20girl%20with%20burn%20injuries%20doing%20rehabilitation%20exercises%2C%20determined%20smile%20despite%20bandages%2C%20physical%20therapy%20equipment%2C%20medical%20staff%20encouraging%20her%2C%20hopeful%20atmosphere%20in%20bright%20rehabilitation%20center%2C%20clean%20background&width=600&height=400&seq=case13&orientation=landscape',
      progress: 71,
      monthlyNeed: 80000,
      supporters: 92,
      raised: 56800,
      donors: [
        { name: '陽光基金會', amount: 20000 },
        { name: '燒燙傷基金會', amount: 15000 },
        { name: '創世基金會', amount: 10000 },
        { name: '門諾基金會', amount: 6800 },
        { name: '華山基金會', amount: 5000 }
      ]
    },
    {
      id: 14,
      name: '小強家庭',
      age: 9,
      type: '癌症治療案例',
      story: '小強被診斷出骨肉瘤，需要截肢手術和化療。家庭為了治療已經負債累累，但父母從未放棄希望。手術和義肢費用需要200,000元，讓小強重新站起來奔跑。',
      image: 'https://readdy.ai/api/search-image?query=A%20young%20boy%20with%20bone%20cancer%20in%20hospital%20bed%20with%20prosthetic%20leg%20nearby%2C%20brave%20smile%20with%20family%20support%2C%20medical%20equipment%20and%20colorful%20drawings%20on%20wall%2C%20hopeful%20atmosphere%20showing%20courage%2C%20clean%20background&width=600&height=400&seq=case14&orientation=landscape',
      progress: 63,
      monthlyNeed: 200000,
      supporters: 145,
      raised: 126000,
      donors: [
        { name: '癌症希望基金會', amount: 40000 },
        { name: '兒童癌症基金會', amount: 30000 },
        { name: '喜憨兒基金會', amount: 25000 },
        { name: '心路基金會', amount: 16000 },
        { name: '勵馨基金會', amount: 15000 }
      ]
    },
    {
      id: 15,
      name: '小慧媽媽',
      age: 42,
      type: '重症母親案例',
      story: '小慧媽媽患有乳癌末期，需要標靶治療延續生命。她最大的願望是能陪伴三個年幼的孩子長大，看到他們成家立業。每月標靶藥物費用需要45,000元。',
      image: 'https://readdy.ai/api/search-image?query=A%20mother%20with%20cancer%20surrounded%20by%20three%20young%20children%2C%20showing%20love%20and%20strength%20despite%20illness%2C%20family%20embracing%20in%20warm%20home%20setting%2C%20hopeful%20expressions%2C%20natural%20lighting%20showing%20maternal%20love%2C%20clean%20background&width=600&height=400&seq=case15&orientation=landscape',
      progress: 49,
      monthlyNeed: 45000,
      supporters: 187,
      raised: 22050,
      donors: [
        { name: '乳癌防治基金會', amount: 8000 },
        { name: '婦女救援基金會', amount: 5000 },
        { name: '現代婦女基金會', amount: 4000 },
        { name: '勵馨基金會', amount: 3050 },
        { name: '善牧基金會', amount: 2000 }
      ]
    }
  ];

  const stats = [
    { number: '2,847', label: '受助兒童', icon: 'ri-heart-fill' },
    { number: '156', label: '合作家庭', icon: 'ri-home-heart-fill' },
    { number: '89%', label: '資金透明度', icon: 'ri-shield-check-fill' },
    { number: '24', label: '活躍志工', icon: 'ri-team-fill' }
  ];

  const donationOptions = [500, 1000, 2000, 5000];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentStory((prev) => (prev + 1) % stories.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const handleDonationSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const formData = new FormData(e.target as HTMLFormElement);
    
    // 如果是針對特定案例的捐款，添加案例信息
    if (selectedCase !== null) {
      formData.append('case_id', selectedCase.toString());
      formData.append('case_name', stories.find(s => s.id === selectedCase)?.name || '');
    }
    
    try {
      const response = await fetch('https://readdy.ai/api/form/d4cnr1edhknumrhf6840', {
        method: 'POST',
        body: new URLSearchParams(formData as any)
      });
      
      if (response.ok) {
        alert('感謝您的愛心捐款！我們會在7個工作天內寄送捐款收據至您的電子郵件，憑此收據可於報稅時申報列舉扣除額。');
        setShowDonationForm(false);
        setDonationAmount('');
        setSelectedCase(null);
      }
    } catch (error) {
      alert('提交失敗，請稍後再試。');
    }
  };

  const handleContactSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const formData = new FormData(e.target as HTMLFormElement);
    
    try {
      const response = await fetch('https://readdy.ai/api/form/d4dimqudhknumrhf6io0', {
        method: 'POST',
        body: new URLSearchParams(formData as any)
      });
      
      if (response.ok) {
        alert('感謝您的留言！我們會盡快回覆您。');
        (e.target as HTMLFormElement).reset();
      } else {
        alert('提交失敗，請稍後再試。');
      }
    } catch (error) {
      alert('提交失敗，請稍後再試。');
    }
  };

  const openDonationForm = (caseId?: number) => {
    if (caseId) {
      setSelectedCase(caseId);
    } else {
      setSelectedCase(null);
    }
    setShowDonationForm(true);
  };

  const maskName = (name: string) => {
    if (name.length <= 1) return name;
    if (name.length === 2) return name[0] + '*';
    return name[0] + '*' + name.slice(2);
  };

  const scrollToCasesAndFilter = (category: string) => {
    setCategoryFilter(category);
    const casesSection = document.getElementById('cases');
    if (casesSection) {
      casesSection.scrollIntoView({ behavior: 'smooth' });
      // 滚动到所有案例网格区域
      setTimeout(() => {
        const allCasesGrid = document.getElementById('all-cases-grid');
        if (allCasesGrid) {
          allCasesGrid.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 500);
    }
  };

  const getCategoryKeywords = (category: string): string[] => {
    const categoryMap: Record<string, string[]> = {
      '教育支援': ['教育', '課輔', '課業', '語言'],
      '醫療協助': ['醫療', '治療', '癌', '病', '症', '燒燙傷', '罕見'],
      '文化傳承': ['文化', '語言', '傳統', '舞蹈'],
      '職業培訓': ['職業', '培訓', '職訓', '家庭扶助']
    };
    return categoryMap[category] || [];
  };

  const filteredStories = categoryFilter 
    ? stories.filter(story => {
        const keywords = getCategoryKeywords(categoryFilter);
        return keywords.some(keyword => story.type.includes(keyword) || story.story.includes(keyword));
      })
    : stories;

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white shadow-sm sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <h1 className="text-2xl font-bold text-orange-600" style={{ fontFamily: '"Pacifico", serif' }}>
                中華原住民暨弱勢家庭孩童關懷協會
              </h1>
            </div>
            <nav className="hidden md:flex space-x-8">
              <a href="#home" className="text-gray-700 hover:text-orange-600 transition-colors cursor-pointer">首頁</a>
              <a href="#cases" className="text-gray-700 hover:text-orange-600 transition-colors cursor-pointer">受助案例</a>
              <a href="#reports" className="text-gray-700 hover:text-orange-600 transition-colors cursor-pointer">透明報告</a>
              <a href="#contact" className="text-gray-700 hover:text-orange-600 transition-colors cursor-pointer">聯絡我們</a>
            </nav>
            <button 
              onClick={() => openDonationForm()}
              className="bg-orange-600 text-white px-6 py-2 rounded-full hover:bg-orange-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              立即捐款
            </button>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section 
        id="home" 
        className="relative h-screen flex items-center justify-center bg-cover bg-center"
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.4)), url('https://readdy.ai/api/search-image?query=Beautiful%20indigenous%20children%20playing%20happily%20in%20a%20traditional%20village%20setting%20with%20mountains%20in%20background%2C%20warm%20golden%20sunlight%2C%20traditional%20houses%20and%20cultural%20elements%2C%20hopeful%20and%20inspiring%20atmosphere%2C%20natural%20landscape%20with%20clear%20sky&width=1920&height=1080&seq=hero&orientation=landscape')`
        }}
      >
        <div className="text-center text-white max-w-4xl mx-auto px-4">
          <h2 className="text-5xl md:text-6xl font-bold mb-6">
            為原住民及弱勢家庭孩童點亮希望
          </h2>
          <p className="text-xl md:text-2xl mb-8 opacity-90">
            每一份愛心，都能改變一個孩子的未來
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button 
              onClick={() => openDonationForm()}
              className="bg-orange-600 text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-orange-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              立即捐款支持
            </button>
            <a 
              href="#cases"
              className="border-2 border-white text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-white hover:text-gray-900 transition-colors whitespace-nowrap cursor-pointer"
            >
              了解更多案例
            </a>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {stats.map((stat, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${stat.icon} text-2xl text-orange-600`}></i>
                </div>
                <div className="text-3xl font-bold text-gray-900 mb-2">{stat.number}</div>
                <div className="text-gray-600">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Cases Section */}
      <section id="cases" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h3 className="text-4xl font-bold text-gray-900 mb-4">感人受助案例</h3>
            <p className="text-xl text-gray-600">每個案例都是希望的見證</p>
          </div>
          
          <div className="relative">
            <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
              <div className="md:flex">
                <div className="md:w-1/2">
                  <img 
                    src={stories[currentStory].image}
                    alt={stories[currentStory].name}
                    className="w-full h-96 object-cover object-top"
                  />
                </div>
                <div className="md:w-1/2 p-8 md:p-12">
                  <div className="flex items-center mb-2">
                    <span className="bg-orange-100 text-orange-600 px-3 py-1 rounded-full text-sm font-medium">
                      {stories[currentStory].type}
                    </span>
                  </div>
                  <div className="flex items-center mb-4">
                    <h4 className="text-2xl font-bold text-gray-900">{stories[currentStory].name}</h4>
                    {stories[currentStory].age > 0 && (
                      <span className="ml-3 text-gray-500">({stories[currentStory].age}歲)</span>
                    )}
                  </div>
                  <p className="text-gray-700 text-lg leading-relaxed mb-6">
                    {stories[currentStory].story}
                  </p>
                  <div className="mb-4">
                    <div className="flex justify-between text-sm text-gray-600 mb-2">
                      <span>援助進度</span>
                      <span>{stories[currentStory].progress}%</span>
                    </div>
                    <div className="w-full bg-gray-200 rounded-full h-3">
                      <div 
                        className="bg-orange-600 h-3 rounded-full transition-all duration-1000"
                        style={{ width: `${stories[currentStory].progress}%` }}
                      ></div>
                    </div>
                  </div>
                  <div className="space-y-2 mb-6">
                    <div className="flex justify-between text-sm">
                      <span className="text-gray-600">需要金額：</span>
                      <span className="font-semibold text-gray-900">NT$ {stories[currentStory].monthlyNeed.toLocaleString()}</span>
                    </div>
                    <div className="flex justify-between text-sm">
                      <span className="text-gray-600">已募得：</span>
                      <span className="text-green-600 font-semibold">NT$ {stories[currentStory].raised.toLocaleString()}</span>
                    </div>
                    <div className="flex justify-between text-sm pb-2 border-b border-gray-200">
                      <span className="text-gray-600">還差：</span>
                      <span className="text-red-600 font-semibold">NT$ {(stories[currentStory].monthlyNeed - stories[currentStory].raised).toLocaleString()}</span>
                    </div>
                    <div className="flex justify-between text-sm text-gray-600 pt-2">
                      <span>支持人數：{stories[currentStory].supporters}人</span>
                    </div>
                  </div>
                  <button 
                    onClick={() => openDonationForm(stories[currentStory].id)}
                    className="bg-orange-600 text-white px-6 py-3 rounded-full hover:bg-orange-700 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    支持這個案例
                  </button>
                </div>
              </div>
            </div>
            
            {/* Case Navigation */}
            <div className="flex justify-center mt-8 space-x-2">
              {stories.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentStory(index)}
                  className={`w-3 h-3 rounded-full transition-colors cursor-pointer ${
                    index === currentStory ? 'bg-orange-600' : 'bg-gray-300'
                  }`}
                />
              ))}
            </div>
          </div>
          
          {/* All Cases Grid */}
          <div id="all-cases-grid" className="mt-20">
            <div className="flex justify-between items-center mb-8">
              <h4 className="text-3xl font-bold text-gray-900">所有受助案例</h4>
              {categoryFilter && (
                <button
                  onClick={() => setCategoryFilter(null)}
                  className="flex items-center gap-2 text-orange-600 hover:text-orange-700 cursor-pointer"
                >
                  <i className="ri-close-circle-line"></i>
                  <span>清除篩選</span>
                </button>
              )}
            </div>
            
            {categoryFilter && (
              <div className="mb-6 p-4 bg-orange-50 border border-orange-200 rounded-lg">
                <p className="text-orange-800">
                  <strong>篩選類別：</strong>{categoryFilter} - 共找到 {filteredStories.length} 個案例
                </p>
              </div>
            )}
            
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {filteredStories.map((caseItem, index) => {
                const originalIndex = stories.findIndex(s => s.id === caseItem.id);
                return (
                  <div key={caseItem.id} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
                    <img 
                      src={caseItem.image}
                      alt={caseItem.name}
                      className="w-full h-48 object-cover object-top"
                    />
                    <div className="p-6">
                      <div className="flex items-center mb-2">
                        <span className="bg-orange-100 text-orange-600 px-2 py-1 rounded-full text-xs font-medium">
                          {caseItem.type}
                        </span>
                      </div>
                      <h5 className="text-xl font-bold text-gray-900 mb-2">
                        {caseItem.name}
                        {caseItem.age > 0 && <span className="text-gray-500 text-sm ml-2">({caseItem.age}歲)</span>}
                      </h5>
                      <p className="text-gray-600 text-sm mb-4 line-clamp-3">
                        {caseItem.story}
                      </p>
                      <div className="mb-4">
                        <div className="flex justify-between text-xs text-gray-500 mb-1">
                          <span>完成率 {caseItem.progress}%</span>
                          <span>{caseItem.supporters}人支持</span>
                        </div>
                        <div className="w-full bg-gray-200 rounded-full h-2">
                          <div 
                            className="bg-orange-600 h-2 rounded-full"
                            style={{ width: `${caseItem.progress}%` }}
                          ></div>
                        </div>
                        <div className="flex justify-between text-xs mt-2">
                          <span className="text-green-600">已募 NT$ {caseItem.raised.toLocaleString()}</span>
                          <span className="text-red-600">還差 NT$ {(caseItem.monthlyNeed - caseItem.raised).toLocaleString()}</span>
                        </div>
                      </div>
                      <div className="flex justify-between items-center">
                        <span className="text-sm font-semibold text-gray-900">
                          NT$ {caseItem.monthlyNeed.toLocaleString()}
                        </span>
                        <div className="flex gap-2">
                          <button 
                            onClick={() => {
                              setCurrentStory(originalIndex);
                              document.getElementById('cases')?.scrollIntoView({ behavior: 'smooth' });
                            }}
                            className="bg-gray-100 text-gray-700 px-3 py-2 rounded-full text-sm hover:bg-gray-200 transition-colors whitespace-nowrap cursor-pointer"
                          >
                            了解詳情
                          </button>
                          <button 
                            onClick={() => openDonationForm(caseItem.id)}
                            className="bg-orange-600 text-white px-3 py-2 rounded-full text-sm hover:bg-orange-700 transition-colors whitespace-nowrap cursor-pointer"
                          >
                            立即捐款
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
            
            {filteredStories.length === 0 && (
              <div className="text-center py-12">
                <i className="ri-folder-open-line text-6xl text-gray-300 mb-4"></i>
                <p className="text-gray-500 text-lg">此類別暫無案例</p>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Transparency Reports */}
      <section id="reports" className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h3 className="text-4xl font-bold text-gray-900 mb-4">透明化報告</h3>
            <p className="text-xl text-gray-600">每一分善款的去向都清楚透明</p>
          </div>
          
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-white rounded-xl shadow-lg p-8">
              <h4 className="text-2xl font-bold text-gray-900 mb-6">資金運用分配</h4>
              <div className="space-y-4">
                <div className="flex justify-between items-center">
                  <span className="text-gray-700">教育支援</span>
                  <div className="flex items-center">
                    <div className="w-32 bg-gray-200 rounded-full h-2 mr-3">
                      <div className="bg-blue-600 h-2 rounded-full" style={{ width: '45%' }}></div>
                    </div>
                    <span className="text-sm font-semibold">45%</span>
                  </div>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-gray-700">醫療協助</span>
                  <div className="flex items-center">
                    <div className="w-32 bg-gray-200 rounded-full h-2 mr-3">
                      <div className="bg-green-600 h-2 rounded-full" style={{ width: '25%' }}></div>
                    </div>
                    <span className="text-sm font-semibold">25%</span>
                  </div>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-gray-700">文化傳承</span>
                  <div className="flex items-center">
                    <div className="w-32 bg-gray-200 rounded-full h-2 mr-3">
                      <div className="bg-purple-600 h-2 rounded-full" style={{ width: '20%' }}></div>
                    </div>
                    <span className="text-sm font-semibold">20%</span>
                  </div>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-gray-700">行政費用</span>
                  <div className="flex items-center">
                    <div className="w-32 bg-gray-200 rounded-full h-2 mr-3">
                      <div className="bg-orange-600 h-2 rounded-full" style={{ width: '10%' }}></div>
                    </div>
                    <span className="text-sm font-semibold">10%</span>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="bg-white rounded-xl shadow-lg p-8">
              <h4 className="text-2xl font-bold text-gray-900 mb-6">最新財務報告</h4>
              <div className="space-y-6">
                <div className="border-l-4 border-orange-600 pl-4">
                  <h5 className="font-semibold text-gray-900">2024年第三季報告</h5>
                  <p className="text-gray-600 text-sm">總收入：NT$ 2,847,000</p>
                  <p className="text-gray-600 text-sm">總支出：NT$ 2,534,000</p>
                  <a href="#" className="text-orange-600 hover:text-orange-700 text-sm cursor-pointer">查看詳細報告 →</a>
                </div>
                <div className="border-l-4 border-gray-300 pl-4">
                  <h5 className="font-semibold text-gray-900">2024年第二季報告</h5>
                  <p className="text-gray-600 text-sm">總收入：NT$ 3,156,000</p>
                  <p className="text-gray-600 text-sm">總支出：NT$ 2,987,000</p>
                  <a href="#" className="text-orange-600 hover:text-orange-700 text-sm cursor-pointer">查看詳細報告 →</a>
                </div>
                <div className="border-l-4 border-gray-300 pl-4">
                  <h5 className="font-semibold text-gray-900">2024年第一季報告</h5>
                  <p className="text-gray-600 text-sm">總收入：NT$ 2,678,000</p>
                  <p className="text-gray-600 text-sm">總支出：NT$ 2,445,000</p>
                  <a href="#" className="text-orange-600 hover:text-orange-700 text-sm cursor-pointer">查看詳細報告 →</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Cultural Activities */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h3 className="text-4xl font-bold text-gray-900 mb-4">服務項目與活動</h3>
            <p className="text-xl text-gray-600">文化傳承、弱勢家庭關懷與社會服務</p>
          </div>
          
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white rounded-xl shadow-lg overflow-hidden">
              <img 
                src="https://readdy.ai/api/search-image?query=Indigenous%20children%20learning%20traditional%20dance%20in%20colorful%20traditional%20costumes%2C%20instructor%20teaching%20dance%20moves%2C%20cultural%20center%20setting%20with%20traditional%20decorations%2C%20joyful%20learning%20atmosphere%2C%20warm%20lighting%20highlighting%20the%20cultural%20heritage&width=400&height=300&seq=dance1&orientation=landscape"
                alt="傳統舞蹈教學"
                className="w-full h-48 object-cover object-top"
              />
              <div className="p-6">
                <h4 className="text-xl font-bold text-gray-900 mb-3">傳統舞蹈教學</h4>
                <p className="text-gray-600 mb-4">每週三次的舞蹈課程，讓孩子們學習祖先的舞蹈，傳承文化精神。</p>
                <div className="text-sm text-gray-500">參與人數：45位孩子</div>
              </div>
            </div>
            
            <div className="bg-white rounded-xl shadow-lg overflow-hidden">
              <img 
                src="https://readdy.ai/api/search-image?query=Volunteers%20visiting%20disadvantaged%20families%20in%20simple%20homes%2C%20bringing%20food%20and%20supplies%2C%20warm%20interaction%20between%20volunteers%20and%20children%2C%20caring%20atmosphere%20showing%20community%20support%2C%20hopeful%20expressions%20on%20children%20faces&width=400&height=300&seq=visit1&orientation=landscape"
                alt="弱勢家庭拜訪"
                className="w-full h-48 object-cover object-top"
              />
              <div className="p-6">
                <h4 className="text-xl font-bold text-gray-900 mb-3">弱勢家庭拜訪</h4>
                <p className="text-gray-600 mb-4">定期拜訪弱勢家庭，提供物資援助、心理支持與生活協助，讓每個家庭都能感受到社會的溫暖。</p>
                <div className="text-sm text-gray-500">服務家庭：156戶</div>
              </div>
            </div>
            
            <div className="bg-white rounded-xl shadow-lg overflow-hidden">
              <img 
                src="https://readdy.ai/api/search-image?query=Social%20workers%20helping%20disadvantaged%20children%20with%20education%20and%20care%2C%20children%20studying%20happily%20in%20community%20center%2C%20volunteers%20teaching%20and%20playing%20with%20kids%2C%20warm%20supportive%20atmosphere%20showing%20hope%20and%20progress&width=400&height=300&seq=help1&orientation=landscape"
                alt="社會弱勢孩童關懷"
                className="w-full h-48 object-cover object-top"
              />
              <div className="p-6">
                <h4 className="text-xl font-bold text-gray-900 mb-3">社會弱勢孩童關懷</h4>
                <p className="text-gray-600 mb-4">提供課業輔導、營養午餐、心理諮商等多元服務，幫助弱勢孩童健康成長，擁有美好未來。</p>
                <div className="text-sm text-gray-500">受助孩童：2,847位</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h3 className="text-4xl font-bold text-gray-900 mb-4">聯絡我們</h3>
            <p className="text-xl text-gray-600">有任何問題或想要參與志工服務，歡迎與我們聯繫</p>
          </div>
          
          <div className="grid md:grid-cols-2 gap-12">
            <div>
              <h4 className="text-2xl font-bold text-gray-900 mb-6">聯絡資訊</h4>
              <div className="space-y-4">
                <div className="flex items-center">
                  <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center mr-4">
                    <i className="ri-phone-fill text-orange-600 text-xl"></i>
                  </div>
                  <div>
                    <div className="font-semibold text-gray-900">電話</div>
                    <div className="text-gray-600">(04) 22436255</div>
                  </div>
                </div>
                <div className="flex items-center">
                  <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center mr-4">
                    <i className="ri-mail-fill text-orange-600 text-xl"></i>
                  </div>
                  <div>
                    <div className="font-semibold text-gray-900">電子郵件</div>
                    <div className="text-gray-600">richqazstrong@yahoo.com.tw</div>
                  </div>
                </div>
                <div className="flex items-center">
                  <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center mr-4">
                    <i className="ri-map-pin-fill text-orange-600 text-xl"></i>
                  </div>
                  <div>
                    <div className="font-semibold text-gray-900">地址</div>
                    <div className="text-gray-600">台中市北屯區北屯路388號2樓</div>
                  </div>
                </div>
                <div className="flex items-center">
                  <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center mr-4">
                    <i className="ri-time-fill text-orange-600 text-xl"></i>
                  </div>
                  <div>
                    <div className="font-semibold text-gray-900">服務時間</div>
                    <div className="text-gray-600">週一至週五 9:00-18:00</div>
                  </div>
                </div>
              </div>
            </div>
            
            <div>
              <form onSubmit={handleContactSubmit} data-readdy-form className="space-y-6">
                <div>
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">姓名</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent"
                  />
                </div>
                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">電子郵件</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent"
                  />
                </div>
                <div>
                  <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-2">電話</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent"
                  />
                </div>
                <div>
                  <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">留言內容</label>
                  <textarea
                    id="message"
                    name="message"
                    rows={4}
                    maxLength={500}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent"
                  ></textarea>
                </div>
                <button
                  type="submit"
                  className="w-full bg-orange-600 text-white py-3 px-6 rounded-lg hover:bg-orange-700 transition-colors font-semibold whitespace-nowrap cursor-pointer"
                >
                  送出留言
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              <h5 className="text-xl font-bold mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
                中華原住民暨弱勢家庭孩童關懷協會
              </h5>
              <p className="text-gray-400 mb-4">
                致力於改善原住民家庭和兒童的生活條件，傳承珍貴的文化遺產。
              </p>
              <div className="flex space-x-4">
                <a href="#" className="text-gray-400 hover:text-white cursor-pointer">
                  <i className="ri-facebook-fill text-xl"></i>
                </a>
                <a href="#" className="text-gray-400 hover:text-white cursor-pointer">
                  <i className="ri-instagram-fill text-xl"></i>
                </a>
                <a href="#" className="text-gray-400 hover:text-white cursor-pointer">
                  <i className="ri-youtube-fill text-xl"></i>
                </a>
              </div>
            </div>
            
            <div>
              <h6 className="font-semibold mb-4">服務項目</h6>
              <ul className="space-y-2 text-gray-400">
                <li>
                  <a 
                    onClick={() => scrollToCasesAndFilter('教育支援')} 
                    className="hover:text-white cursor-pointer"
                  >
                    教育支援
                  </a>
                </li>
                <li>
                  <a 
                    onClick={() => scrollToCasesAndFilter('醫療協助')} 
                    className="hover:text-white cursor-pointer"
                  >
                    醫療協助
                  </a>
                </li>
                <li>
                  <a 
                    onClick={() => scrollToCasesAndFilter('文化傳承')} 
                    className="hover:text-white cursor-pointer"
                  >
                    文化傳承
                  </a>
                </li>
                <li>
                  <a 
                    onClick={() => scrollToCasesAndFilter('職業培訓')} 
                    className="hover:text-white cursor-pointer"
                  >
                    職業培訓
                  </a>
                </li>
              </ul>
            </div>
            
            <div>
              <h6 className="font-semibold mb-4">關於我們</h6>
              <ul className="space-y-2 text-gray-400">
                <li>
                  <a 
                    href="#home" 
                    className="hover:text-white cursor-pointer"
                  >
                    組織介紹
                  </a>
                </li>
                <li>
                  <a 
                    href="#contact" 
                    className="hover:text-white cursor-pointer"
                  >
                    志工招募
                  </a>
                </li>
                <li>
                  <a 
                    href="#reports" 
                    className="hover:text-white cursor-pointer"
                  >
                    合作夥伴
                  </a>
                </li>
                <li>
                  <a 
                    href="#cases" 
                    className="hover:text-white cursor-pointer"
                  >
                    媒體報導
                  </a>
                </li>
              </ul>
            </div>
            
            <div>
              <h6 className="font-semibold mb-4">聯絡資訊</h6>
              <ul className="space-y-2 text-gray-400">
                <li>電話：(04) 22436255</li>
                <li>信箱：richqazstrong@yahoo.com.tw</li>
                <li>地址：台中市北屯區北屯路388號2樓</li>
              </ul>
            </div>
          </div>
          
          <div className="border-t border-gray-800 mt-8 pt-8">
            <div className="mb-6">
              <h6 className="font-semibold mb-4 text-center">合作企業</h6>
              <div className="flex flex-wrap justify-center gap-6 text-gray-400 text-sm">
                <a href="https://www.cmapedu.com" target="_blank" rel="noopener noreferrer" className="hover:text-white cursor-pointer transition-colors">
                  CMAP運動健康品格寒假營隊
                </a>
                <span className="text-gray-600">|</span>
                <a href="https://www.cmleducate.com" target="_blank" rel="noopener noreferrer" className="hover:text-white cursor-pointer transition-colors">
                  CM探索教育科技股份有限公司
                </a>
                <span className="text-gray-600">|</span>
                <a href="https://www.yeswecanedu.com" target="_blank" rel="noopener noreferrer" className="hover:text-white cursor-pointer transition-colors">
                  威斯理美語補習班
                </a>
              </div>
            </div>

            <div className="flex flex-col md:flex-row justify-between items-center">
              <p className="text-gray-400 text-sm">
                © 2024 中華原住民暨弱勢家庭孩童關懷協會. 版權所有.
              </p>
              <a 
                href="https://readdy.ai/?origin=logo" 
                className="text-gray-400 hover:text-white text-sm cursor-pointer mt-4 md:mt-0"
              >
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </footer>

      {/* Donation Modal */}
      {showDonationForm && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl max-w-md w-full max-h-[90vh] overflow-y-auto">
            <div className="p-6">
              <div className="flex justify-between items-center mb-6">
                <h3 className="text-2xl font-bold text-gray-900">
                  {selectedCase ? `支持 ${stories.find(s => s.id === selectedCase)?.name} 案例` : '愛心捐款'}
                </h3>
                <button 
                  onClick={() => setShowDonationForm(false)}
                  className="text-gray-400 hover:text-gray-600 cursor-pointer"
                >
                  <i className="ri-close-line text-2xl"></i>
                </button>
              </div>
              
              {/* 抵稅說明 */}
              <div className="mb-6 p-4 bg-blue-50 border border-blue-200 rounded-lg">
                <div className="flex items-start">
                  <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center mr-3 flex-shrink-0">
                    <i className="ri-file-text-fill text-blue-600 text-lg"></i>
                  </div>
                  <div>
                    <h5 className="font-semibold text-blue-900 mb-1">捐款可抵稅說明</h5>
                    <p className="text-sm text-blue-800 leading-relaxed">
                      本協會為合法立案之公益團體，您的捐款可依所得稅法第17條規定，於申報綜合所得稅時列舉扣除。我們將於7個工作天內寄送正式捐款收據至您的電子郵件，請妥善保存以供報稅使用。
                    </p>
                  </div>
                </div>
              </div>

              {selectedCase && (
                <div className="mb-6 p-4 bg-orange-50 rounded-lg">
                  <div className="flex items-center mb-2">
                    <span className="bg-orange-100 text-orange-600 px-2 py-1 rounded-full text-xs font-medium">
                      {stories.find(s => s.id === selectedCase)?.type}
                    </span>
                  </div>
                  <h4 className="font-bold text-gray-900 mb-1">
                    {stories.find(s => s.id === selectedCase)?.name}
                  </h4>
                  <div className="space-y-1 text-sm mb-2">
                    <div className="flex justify-between">
                      <span className="text-gray-600">需要金額：</span>
                      <span className="font-semibold">NT$ {stories.find(s => s.id === selectedCase)?.monthlyNeed.toLocaleString()}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">已募得：</span>
                      <span className="text-green-600 font-semibold">NT$ {stories.find(s => s.id === selectedCase)?.raised.toLocaleString()}</span>
                    </div>
                    <div className="flex justify-between pb-2 border-b border-orange-200">
                      <span className="text-gray-600">還差：</span>
                      <span className="text-red-600 font-semibold">NT$ {((stories.find(s => s.id === selectedCase)?.monthlyNeed || 0) - (stories.find(s => s.id === selectedCase)?.raised || 0)).toLocaleString()}</span>
                    </div>
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-2 mb-1">
                    <div 
                      className="bg-orange-600 h-2 rounded-full"
                      style={{ width: `${stories.find(s => s.id === selectedCase)?.progress}%` }}
                    ></div>
                  </div>
                  <div className="text-xs text-gray-500">
                    完成率：{stories.find(s => s.id === selectedCase)?.progress}%
                  </div>
                </div>
              )}
              
              <form onSubmit={handleDonationSubmit} data-readdy-form className="space-y-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-3">選擇捐款金額</label>
                  <div className="grid grid-cols-2 gap-3 mb-4">
                    {donationOptions.map((amount) => (
                      <button
                        key={amount}
                        type="button"
                        onClick={() => setDonationAmount(amount.toString())}
                        className={`p-3 border rounded-lg text-center cursor-pointer ${
                          donationAmount === amount.toString()
                            ? 'border-orange-600 bg-orange-50 text-orange-600'
                            : 'border-gray-300 hover:border-orange-300'
                        }`}
                      >
                        NT$ {amount.toLocaleString()}
                      </button>
                    ))}
                  </div>
                  <input
                    type="number"
                    name="amount"
                    value={donationAmount}
                    onChange={(e) => setDonationAmount(e.target.value)}
                    placeholder="或輸入其他金額"
                    min="100"
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent"
                  />
                </div>
                
                <div>
                  <label htmlFor="donor_name" className="block text-sm font-medium text-gray-700 mb-2">
                    捐款人姓名 <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    id="donor_name"
                    name="donor_name"
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent"
                    placeholder="請填寫收據上的姓名"
                  />
                  <p className="text-xs text-gray-500 mt-1">此姓名將顯示於捐款收據上</p>
                </div>
                
                <div>
                  <label htmlFor="donor_email" className="block text-sm font-medium text-gray-700 mb-2">
                    電子郵件 <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="email"
                    id="donor_email"
                    name="donor_email"
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent"
                    placeholder="用於接收捐款收據"
                  />
                  <p className="text-xs text-gray-500 mt-1">捐款收據將寄送至此信箱</p>
                </div>
                
                <div>
                  <label htmlFor="donor_phone" className="block text-sm font-medium text-gray-700 mb-2">聯絡電話</label>
                  <input
                    type="tel"
                    id="donor_phone"
                    name="donor_phone"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent"
                  />
                </div>

                <div>
                  <label htmlFor="tax_id" className="block text-sm font-medium text-gray-700 mb-2">
                    身分證字號/統一編號（選填）
                  </label>
                  <input
                    type="text"
                    id="tax_id"
                    name="tax_id"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent"
                    placeholder="用於開立正式收據"
                  />
                  <p className="text-xs text-gray-500 mt-1">提供此資訊可加快收據開立流程</p>
                </div>
                
                <div>
                  <label htmlFor="donation_message" className="block text-sm font-medium text-gray-700 mb-2">留言給孩子們（選填）</label>
                  <textarea
                    id="donation_message"
                    name="donation_message"
                    rows={3}
                    maxLength={500}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent"
                    placeholder="您的鼓勵將成為孩子們前進的動力..."
                  ></textarea>
                </div>
                
                <button
                  type="submit"
                  className="w-full bg-orange-600 text-white py-3 px-6 rounded-lg hover:bg-orange-700 transition-colors font-semibold whitespace-nowrap cursor-pointer"
                >
                  確認捐款
                </button>

                {selectedCase && (
                  <div className="mt-6 pt-6 border-t border-gray-200">
                    <h5 className="text-sm font-semibold text-gray-900 mb-3">最近捐款記錄</h5>
                    <div className="space-y-2 max-h-48 overflow-y-auto">
                      {stories.find(s => s.id === selectedCase)?.donors.map((donor, idx) => (
                        <div key={idx} className="flex justify-between items-center text-sm py-2 px-3 bg-gray-50 rounded-lg">
                          <span className="text-gray-700">{maskName(donor.name)}</span>
                          <span className="font-semibold text-orange-600">NT$ {donor.amount.toLocaleString()}</span>
                        </div>
                      ))}
                    </div>
                    <div className="mt-3 text-xs text-gray-500 text-center">
                      感謝所有愛心捐款人的支持
                    </div>
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default HomePage;
